
<div class="relative" :class="textAreaClasses">
  <textarea
    :id="id"
    ref="textAreaRef"
    v-model="content"
    :status="status"
    :class="computeClasses"
    :aria-invalid="hasError"
    :aria-describedby="ariaDescribedByName"
    :required="required"
    :disabled="disabled"
    :readonly="readonly"
    :rows="rows"
    @input="charCountHandler"
    @keyup.once="$emit('keyupOnce')"
    @blur="checkValidation()"
    @click="$emit('click')"
  />
  <label :class="`${textAreaLabelClasses} touch-none pointer-events-none`" :for="id">{{ labelName }}</label>
  <HelperText v-if="helperTextMessage" :id="id" :text="helperTextMessage" :status="helperStatus" />
</div>
